import React, { useState, useEffect } from 'react';
import { useAPI } from '../../api';
import { useNavigate } from 'react-router-dom';
import { AccountInfo, NewTenant } from 'types';

interface SystemTenantCreateNewProps {
	onChanged: () => void;
}

const TenantCreateNewContainer = ({ onChanged }: SystemTenantCreateNewProps) => {
	const api = useAPI();
	const navigate = useNavigate();

	const [accounts, setAccounts] = useState<AccountInfo[]>([]);
	const [tenant, setTenant] = useState<NewTenant>({ id: '', name: '', accountID: '' });

	useEffect(() => {
		api.get<AccountInfo[]>('/api/accounts')
		.then(json => {
			setAccounts(json);
			if (json.length === 1) {
				setTenant(prev => ({ ...prev, accountID: json[0].id }));
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const createTenant = () => {
		if (!tenant.accountID) return alert('Please select an account');
		if (!tenant.name.trim()) return alert('Tenant name is required');

		api.post<NewTenant>('/api/tenants', tenant)
		.then(json => { onChanged(); navigate(`/settings/tenants/${json.id}`); });
	};

	return (
		<div>
			<h2>Create new tenant</h2>

			<hr />

			<table>
				<tbody>
					<tr>
						<td>Account</td>
						<td>
							<select value={tenant.accountID} onChange={e => setTenant({ ...tenant, accountID: e.target.value })}>
								<option value="">Select Account...</option>
								{accounts.map(account => (
									<option key={account.id} value={account.id}>{account.name}</option>
								))}
							</select>
						</td>
					</tr>
					<tr>
						<td>Tenant Name</td>
						<td><input type="text" value={tenant.name} onChange={e => setTenant({ ...tenant, name: e.target.value })} /></td>
					</tr>
					<tr>
						<td>Tenant ID (optional)</td>
						<td><input type="text" value={tenant.id} onChange={e => setTenant({ ...tenant, id: e.target.value })} /></td>
					</tr>
					<tr>
						<td></td>
						<td><input type="button" value="Create Tenant" onClick={createTenant} /></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default TenantCreateNewContainer;
